<template>
  <div ref="container" class="container">
    <div>
      <WikiLogo @trigger-parent-animation="PlayAnimation"></WikiLogo>
    </div>
    <div ref="Book">
    <Animation />
    </div>
  </div>
</template>

<script>
import WikiLogo from '../components/WikiLogo.vue' 
import Animation from '../components/HomeAnimation.vue'

export default {
  components: {
    WikiLogo,
    Animation
  },
  methods: {
    nextAbled(nextabled) {
      this.mascotabled=nextabled
    },
    PlayAnimation() {
      this.BookAnimationClass = "animate__animated animate__zoomIn"; // 设置animate.css动画类
      setTimeout(() => {
        this.$refs.Book.scrollIntoView({ behavior: 'smooth', block: 'start' });
       }, 300)
      },
    hideDiv() {
        this.BookAnimationClass = ''
    },
  },
};
</script>

<style scoped>
.container{
    background: url(https://static.igem.wiki/teams/5298/assets/bg.jpg) no-repeat;
    background-size:100% 100%;
    background-attachment:fixed;
}
</style>
